import { Subject } from "rxjs";

export const statsAndResourcesCacheBuster$ = new Subject<void>(); 
export const adminCacheBuster$ = new Subject<void>(); 
export const specificationCacheBuster$ = new Subject<void>();
export const plansCacheBuster$ = new Subject<void>();